// import { createStackNavigator } from "@react-navigation/stack";
// import HomeScreen from "../homeScreen/HomeScreen";
// import ADoingScreen from "../aDoingScreen/ADoingScreen";
// import APullScreen from "../aPullScreen/APullScreen";
// import ViewMoreScreen from "../viewMoreScreens/ViewMoreScreen";
// import ProfileScreen from "../profileScreen/ProfileScreen";
// import AGiveawayPullScreen from "../aGiveawayPull/AGiveawayPullScreen";
// import AccountsScreen from "../accounts/AccountsScreen";
// import FriendsListScreen from "../friendsListScreen/FriendsListScreen";
// import BussinessPage from "../bussiness/BussinessPage";
// import Create_a_Brand from "../bussiness/Create_a_Brand";
// import ManageBrandActivities from "../bussiness/ManageBrandActivities";
// import TablesForBidding from "../bussiness/TablesForBidding";
// import CreateShowOrTable from "../bussiness/CreateShowOrTable";
// import TablesForBiddingNoShow from "../bussiness/TablesForBiddingNoShow";
// import ManageTableBids from "../bussiness/ManageTableBids";
// import ManageCreatedTables from "../bussiness/ManageCreatedTables";
// import WalletScreen from "../wallet/WalletScreen";
// import ManageWalkInAccess from "../bussiness/ManageWalkInAccess";
// import CreateWalkInAccess from "../bussiness/CreateWalkInAccess";
// import ShowQRCode from "../bussiness/ShowQRCode";
// import MeezaCreditScreen from "../wallet/MeezaCreditScreen";
// import TransactionCodeSetUpScreen from "../transactionDigitCode/TransactionCodeSetUpScreen";
// import HowToSpend from "../homeScreen/HowToSpend";
// import TicketsPage from "../homeScreen/TicketsPage";
// import MinimumSpendPage from "../homeScreen/MinimumSpendPage";
// import UseCreditsScreen from "../useCredits/UseCreditsScreen";
// import ManageWaiters from "../bussiness/ManageWaiters";
// import MinimumSpendsPageII from "../homeScreen/MinimumSpendsPageII";
// import SelectTableScreen from "../selectTableScreen/SelectTableScreen";
// import AnonymousOnboarding from "../anonymousOnboarding/AnonymousOnboarding";
// import TopupAmountScreen from "../selectTableScreen/TopupAmountScreen";
// import PayForTable from "../anonymousOnboarding/PayForTable";
// import AddWaiters from "../bussiness/AddWaiters";
// import WalletAndTransfers from "../bussiness/WalletAndTransfers";
// import TransferHistoryList from "../bussiness/TransferHistoryList";
// import UpdateProfilePage from "../profileScreen/UpdateProfilePage";
// import PublicProfile from "../publicProfile/PublicProfile";
// import WaitForBillsPage from "../anonymousOnboarding/WaitForBillsPage";
// import MenuManagementScreen from "../bussiness/MenuManagementScreen";
// import ReviewAndPay from "../bussiness/ReviewAndPay";
// import ManageOrders from "../bussiness/ManageOrders";
// import BusinessBankDetails from "../bussiness/BusinessBankDetails";
// import ChooseYourFlexSpend from "../anonymousOnboarding/ChooseYourFlexSpend";
// import BrandMenuScreen from "../anonymousOnboarding/BrandMenuScreen";
// import RevisitChooseYourSpend from "../anonymousOnboarding/RevisitChooseYourSpend";
// import RevisitMenu from "../anonymousOnboarding/RevisitMenu";
// import PrinterScreen from "../bussiness/PrinterScreen";
// import CreateShowScreen from "../bussiness/CreateShowScreen";
// import ShowsListScreen from "../bussiness/ShowsListScreen";
// import ShowAnalyticsScreen from "../bussiness/ShowAnalyticsScreen";
// import AcknowledgeRedemptionScreen from "../bussiness/AcknowledgeRedemptionScreen";

// import AnonymousOnboarding from "../anonymousOnboarding/AnonymousOnboarding";
// import AnonymousOnboardingOTP from "../anonymousOnboarding/AnonymousOnboardingOTP";

import { createStackNavigator } from "@react-navigation/stack";
import { lazyScreen } from "../../utils/lazyScreen";
import HomeScreen from "../homeScreen/HomeScreen";

const ADoingScreen = lazyScreen(() => import("../aDoingScreen/ADoingScreen"));
const APullScreen = lazyScreen(() => import("../aPullScreen/APullScreen"));
const ViewMoreScreen = lazyScreen(() => import("../viewMoreScreens/ViewMoreScreen"));
const ProfileScreen = lazyScreen(() => import("../profileScreen/ProfileScreen"));
const AGiveawayPullScreen = lazyScreen(() => import("../aGiveawayPull/AGiveawayPullScreen"));
const AccountsScreen = lazyScreen(() => import("../accounts/AccountsScreen"));
const FriendsListScreen = lazyScreen(() => import("../friendsListScreen/FriendsListScreen"));
const BussinessPage = lazyScreen(() => import("../bussiness/BussinessPage"));
const Create_a_Brand = lazyScreen(() => import("../bussiness/Create_a_Brand"));
const ManageBrandActivities = lazyScreen(() => import("../bussiness/ManageBrandActivities"));
const TablesForBidding = lazyScreen(() => import("../bussiness/TablesForBidding"));
const CreateShowOrTable = lazyScreen(() => import("../bussiness/CreateShowOrTable"));
const TablesForBiddingNoShow = lazyScreen(() => import("../bussiness/TablesForBiddingNoShow"));
const ManageTableBids = lazyScreen(() => import("../bussiness/ManageTableBids"));
const ManageCreatedTables = lazyScreen(() => import("../bussiness/ManageCreatedTables"));
const ManageWalkInAccess = lazyScreen(() => import("../bussiness/ManageWalkInAccess"));
const CreateWalkInAccess = lazyScreen(() => import("../bussiness/CreateWalkInAccess"));
const ShowQRCode = lazyScreen(() => import("../bussiness/ShowQRCode"));
const MeezaCreditScreen = lazyScreen(() => import("../wallet/MeezaCreditScreen"));
const TransactionCodeSetUpScreen = lazyScreen(
  () => import("../transactionDigitCode/TransactionCodeSetUpScreen"),
);
const HowToSpend = lazyScreen(() => import("../homeScreen/HowToSpend"));
const TicketsPage = lazyScreen(() => import("../homeScreen/TicketsPage"));
const MinimumSpendPage = lazyScreen(() => import("../homeScreen/MinimumSpendPage"));
const UseCreditsScreen = lazyScreen(() => import("../useCredits/UseCreditsScreen"));
const ManageWaiters = lazyScreen(() => import("../bussiness/ManageWaiters"));
const MinimumSpendsPageII = lazyScreen(() => import("../homeScreen/MinimumSpendsPageII"));
const SelectTableScreen = lazyScreen(() => import("../selectTableScreen/SelectTableScreen"));
const AnonymousOnboarding = lazyScreen(() => import("../anonymousOnboarding/AnonymousOnboarding"));
const TopupAmountScreen = lazyScreen(() => import("../selectTableScreen/TopupAmountScreen"));
const PayForTable = lazyScreen(() => import("../anonymousOnboarding/PayForTable"));
const AddWaiters = lazyScreen(() => import("../bussiness/AddWaiters"));
const WalletAndTransfers = lazyScreen(() => import("../bussiness/WalletAndTransfers"));
const TransferHistoryList = lazyScreen(() => import("../bussiness/TransferHistoryList"));
const UpdateProfilePage = lazyScreen(() => import("../profileScreen/UpdateProfilePage"));
const PublicProfile = lazyScreen(() => import("../publicProfile/PublicProfile"));
const WaitForBillsPage = lazyScreen(() => import("../anonymousOnboarding/WaitForBillsPage"));
const MenuManagementScreen = lazyScreen(() => import("../bussiness/MenuManagementScreen"));
const ReviewAndPay = lazyScreen(() => import("../bussiness/ReviewAndPay"));
const ManageOrders = lazyScreen(() => import("../bussiness/ManageOrders"));
const BusinessBankDetails = lazyScreen(() => import("../bussiness/BusinessBankDetails"));
const ChooseYourFlexSpend = lazyScreen(() => import("../anonymousOnboarding/ChooseYourFlexSpend"));
const BrandMenuScreen = lazyScreen(() => import("../anonymousOnboarding/BrandMenuScreen"));
const RevisitChooseYourSpend = lazyScreen(
  () => import("../anonymousOnboarding/RevisitChooseYourSpend"),
);
const RevisitMenu = lazyScreen(() => import("../anonymousOnboarding/RevisitMenu"));
const PrinterScreen = lazyScreen(() => import("../bussiness/PrinterScreen"));
const CreateShowScreen = lazyScreen(() => import("../bussiness/CreateShowScreen"));
const ShowsListScreen = lazyScreen(() => import("../bussiness/ShowsListScreen"));
const ShowAnalyticsScreen = lazyScreen(() => import("../bussiness/ShowAnalyticsScreen"));
const AcknowledgeRedemptionScreen = lazyScreen(
  () => import("../bussiness/AcknowledgeRedemptionScreen"),
);

const HomeNavigation = () => {
  const Stack = createStackNavigator();

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Home" component={HomeScreen} />
      <Stack.Screen name="a_Doing" component={ADoingScreen} />
      <Stack.Screen name="reviewAndPay" component={ReviewAndPay} />
      <Stack.Screen name="profile" component={ProfileScreen} />
      <Stack.Screen name="public_profile" component={PublicProfile} />
      <Stack.Screen name="bio_update" component={UpdateProfilePage} />
      <Stack.Screen name="a_PullScreen" component={APullScreen} />
      <Stack.Screen name="a_giveawayPullScreen" component={AGiveawayPullScreen} />
      <Stack.Screen name="viewmore" component={ViewMoreScreen} />
      <Stack.Screen name="accounts" component={AccountsScreen} />
      <Stack.Screen name="friendsList" component={FriendsListScreen} />
      <Stack.Screen name="selectTableScreen" component={SelectTableScreen} />
      <Stack.Screen name="topupAmountScreen" component={TopupAmountScreen} />
      <Stack.Screen name="checkMyBill" component={WaitForBillsPage} />

      <Stack.Screen name="meezaCreditScreen" component={MeezaCreditScreen} />
      <Stack.Screen name="transactionCodeSetup" component={TransactionCodeSetUpScreen} />

      <Stack.Screen name="business_page" component={BussinessPage} />
      <Stack.Screen name="create_a_brand" component={Create_a_Brand} />
      <Stack.Screen name="business_bank_details" component={BusinessBankDetails} />
      <Stack.Screen name="menuManagementScreen" component={MenuManagementScreen} />
      <Stack.Screen name="acknowledgeRedemption" component={AcknowledgeRedemptionScreen} />
      <Stack.Screen name="promoterShowListScreen" component={ShowsListScreen} />
      <Stack.Screen name="showAnalyticsScreen" component={ShowAnalyticsScreen} />
      <Stack.Screen name="manageOrders" component={ManageOrders} />
      <Stack.Screen name="choose_a_Flex" component={ChooseYourFlexSpend} />
      <Stack.Screen name="brand_Menu" component={BrandMenuScreen} />
      <Stack.Screen name="manageBrand" component={ManageBrandActivities} />
      <Stack.Screen name="createwithshow" component={TablesForBidding} />
      <Stack.Screen name="createwithoutshow" component={TablesForBiddingNoShow} />
      <Stack.Screen name="howToSpend" component={HowToSpend} />
      <Stack.Screen name="ticketsPage" component={TicketsPage} />
      <Stack.Screen name="minimumSpend" component={MinimumSpendPage} />
      <Stack.Screen name="manageTableBids" component={ManageTableBids} />
      <Stack.Screen name="manageCreatedTables" component={ManageCreatedTables} />
      <Stack.Screen name="manageWaiters" component={ManageWaiters} />
      <Stack.Screen name="createWalkInAccess" component={CreateWalkInAccess} />
      <Stack.Screen name="manageWalkInAccess" component={ManageWalkInAccess} />
      <Stack.Screen name="tableOrShow" component={CreateShowOrTable} />
      <Stack.Screen name="createShow" component={CreateShowScreen} />
      <Stack.Screen name="showQRCode" component={ShowQRCode} />
      <Stack.Screen name="addWaiters" component={AddWaiters} />
      <Stack.Screen name="walletAndTransfers" component={WalletAndTransfers} />
      <Stack.Screen name="transferHistoryList" component={TransferHistoryList} />

      <Stack.Screen name="useCreditsScreen" component={UseCreditsScreen} />

      <Stack.Screen name="minspend" component={MinimumSpendsPageII} />

      <Stack.Screen name="payForVirtualTable" component={PayForTable} />

      <Stack.Screen name="printerScreen" component={PrinterScreen} />

      {/* <Stack.Screen name="anonymousOnboardingOTP" component={AnonymousOnboardingOTP} />  */}
    </Stack.Navigator>
  );
};

export default HomeNavigation;
